import CRUDService from 'src/services/CRUDService';

export interface Country {
  name: string;
  code: string;
}

export default new CRUDService<Country>('/v1/countries');
